// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
var get_entries_desktop = pl => [{
  tag: 'h2',
  id: 'articles',
  title: 'Articles in this section',
  tech: true
}, {
  tag: 'h3',
  id: 'cant_access',
  title: 'Hola is on, but I still can\'t access the ' + 'webpage I want'
}, pl == 'windows' && {
  tag: 'h3',
  id: 'cant_connect',
  title: 'Hola desktop app doesn\'t connect'
}, {
  tag: 'h3',
  id: 'cant_connect_manually',
  title: 'I can\'t establish manual connection'
}, {
  tag: 'h3',
  id: 'slow_speed',
  title: 'Why do I get slow speeds?'
}, {
  tag: 'h3',
  id: 'manual_connect',
  title: 'How to establish manual connection?'
}, {
  tag: 'h3',
  id: 'best_way_to_test',
  title: 'What is the best way to test my Internet speed?'
},
// Keep connection error sections at the end of this list.
pl == 'windows' && {
  tag: 'h3',
  id: 'vpn_error_87',
  title: 'How to handle connection error 87?'
}, pl == 'windows' && {
  tag: 'h3',
  id: 'vpn_error_720',
  title: 'How to handle connection error 720?'
}, pl == 'windows' && {
  tag: 'h3',
  id: 'vpn_error_13801',
  title: 'How to handle connection error 13801?'
}].filter(v => !!v);
var get_entries_mobile = pl => [{
  tag: 'h2',
  id: 'articles',
  title: 'Articles in this section',
  tech: true
}, {
  tag: 'h3',
  id: 'cant_access',
  title: 'Hola is on, but I still can\'t access the ' + 'app I want'
}, {
  tag: 'h3',
  id: 'cant_connect',
  title: 'Hola app doesn\'t connect'
}, {
  tag: 'h3',
  id: 'send_logs',
  title: 'How to send connection logs?'
},
/* pl=='android' && {
    tag: 'h3',
    id: 'install_apk',
    title: 'How to install APK on your device',
}, */
pl == 'ios' && {
  tag: 'h3',
  id: 'establish_manual',
  title: 'How to establish manual connection?'
}].filter(v => !!v);
export var desktop = {
  windows: {
    entries: get_entries_desktop('windows')
  },
  mac: {
    entries: get_entries_desktop('mac')
  }
};
export var extension = {
  entries: [{
    tag: 'h2',
    id: 'articles',
    title: 'Articles in this section',
    tech: true
  }, {
    tag: 'h3',
    id: 'cant_access',
    title: 'Hola is on, but I still can\'t access the ' + 'webpage I want'
  }, {
    tag: 'h3',
    id: 'error',
    title: 'I see the following message: \'There seems to be an ' + 'error - Reload Hola\''
  }, {
    tag: 'h3',
    id: 'slow_speed',
    title: 'My browsing speed is very slow when Hola is on'
  }, {
    tag: 'h3',
    id: 'best_way_to_test',
    title: 'What is the best way to test my Internet speed?'
  }, {
    tag: 'h3',
    id: 'pin_ext',
    title: 'How to pin Hola extension in my browser?'
  }]
};
export var mobile = {
  ios: {
    entries: get_entries_mobile('ios')
  },
  android: {
    entries: get_entries_mobile('android')
  }
};
export var tv = {
  fire: {
    entries: [{
      tag: 'h2',
      id: 'articles',
      title: 'Articles in this section',
      tech: true
    }, {
      tag: 'h3',
      id: 'cant_access',
      title: 'Hola is on, but I still can\'t access the ' + 'app I want'
    }, {
      tag: 'h3',
      id: 'cant_connect',
      title: 'Hola app doesn\'t connect'
    }, {
      tag: 'h3',
      id: 'firestick_buffering',
      title: 'Why is my Firestick constantly buffering?'
    }]
  },
  smart: {
    entries: [{
      tag: 'h2',
      id: 'articles',
      title: 'Articles in this section',
      tech: true
    }, {
      tag: 'h3',
      id: 'cant_access',
      title: 'Hola DNS Proxy is set up, but I still can\'t ' + 'access the web page/streaming app I want.'
    }, {
      tag: 'h3',
      id: 'cant_connect',
      title: 'I can\'t establish connection'
    }]
  }
};
export var billing = {
  entries: [{
    tag: 'h2',
    id: 'articles',
    title: 'Articles in this section',
    tech: true
  }, {
    tag: 'h3',
    id: 'cancel_recurring',
    title: 'How can I cancel my recurring payment?'
  }, {
    tag: 'h3',
    id: 'refund_policy',
    title: 'Refund & Cancelation policy'
  }, {
    tag: 'h3',
    id: 'receive_refund',
    title: 'When will I receive my refund?'
  }, {
    tag: 'h3',
    id: 'where_refund',
    title: 'I requested a refund more than 7 business days ago, ' + 'but I still do not see it in my bank account. Where is ' + 'my refund?'
  }, {
    tag: 'h3',
    id: 'hidden_costs',
    title: 'Are there any additional payments or hidden costs?'
  }, {
    tag: 'h3',
    id: 'change_payment_info',
    title: 'How do I change my payment information?'
  }, {
    tag: 'h3',
    id: 'change_plan',
    title: 'How do I change my plan?'
  }, {
    tag: 'h3',
    id: 'not_active',
    title: 'My account is still not active, even after making a ' + 'payment.'
  }, {
    tag: 'h3',
    id: 'no_activation_email',
    title: 'I did not receive an activation email.'
  }, {
    tag: 'h3',
    id: 'change_email',
    title: 'How do I change my email address?'
  }, {
    tag: 'h3',
    id: 'still_free',
    title: 'My account still appears as free, even after making a ' + 'payment.'
  }, {
    tag: 'h3',
    id: 'cant_make_payment',
    title: 'Why am I unable to make a payment?'
  }, {
    tag: 'h3',
    id: 'add_login_method',
    title: 'I signed up using my Google/Facebook account, how can ' + 'I add an email login method?'
  }]
};
export var affiliate = {
  entries: [{
    tag: 'h2',
    id: 'articles',
    title: 'Questions in this section',
    tech: true
  }, {
    tag: 'h3',
    id: 'aff_program',
    title: 'What is Hola’s Affiliate Program?'
  }, {
    tag: 'h3',
    id: 'how_much',
    title: 'How much can I earn through Hola’s Affiliate ' + 'Program?'
  }, {
    tag: 'h3',
    id: 'how_become',
    title: 'How do I become a Hola Affiliate?'
  }, {
    tag: 'h3',
    id: 'own_website',
    title: 'Do I need to own a website to become an Affiliate?'
  }, {
    tag: 'h3',
    id: 'tech_skills',
    title: 'Which technical skills are required to become an ' + 'Affiliate?'
  }, {
    tag: 'h3',
    id: 'track_transactions',
    title: 'How will you track my transactions to calculate my ' + 'commissions?'
  }, {
    tag: 'h3',
    id: 'track_duration',
    title: 'What is the tracking duration?'
  }, {
    tag: 'h3',
    id: 'track_where',
    title: 'Where can I track my sales and commissions?'
  }, {
    tag: 'h3',
    id: 'track_code',
    title: 'Where can I get my affiliate tracking code and ' + 'marketing assets?'
  }, {
    tag: 'h3',
    id: 'pay_threshold',
    title: 'What is the minimum payment threshold?'
  }, {
    tag: 'h3',
    id: 'pay_methods',
    title: 'What payment methods do you offer?'
  }, {
    tag: 'h3',
    id: 'pay_receive',
    title: 'How often will I receive my payment?'
  }]
};